var _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinerSection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 1.89543 1.89543 1 3 1H33C34.1046 1 35 1.89543 35 3V19C35 20.1046 34.1046 21 33 21H3C1.89543 21 1 20.1046 1 19V3Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 6.25879C10.75 4.74001 11.9812 3.50879 13.5 3.50879H22.6111C24.1299 3.50879 25.3611 4.74001 25.3611 6.25879V15.5002C25.3611 17.019 24.1299 18.2502 22.6111 18.2502H13.5C11.9812 18.2502 10.75 17.019 10.75 15.5002V6.25879Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2394 10.9209C24.2394 14.3462 21.487 17.1192 18.0963 17.1192C14.7055 17.1192 11.9531 14.3462 11.9531 10.9209C11.9531 7.4957 14.7055 4.72266 18.0963 4.72266C21.487 4.72266 24.2394 7.4957 24.2394 10.9209Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4554 10.8801C22.4554 13.3341 20.4836 15.3198 18.0558 15.3198C15.628 15.3198 13.6562 13.3341 13.6562 10.8801C13.6562 8.42611 15.628 6.44043 18.0558 6.44043C20.4836 6.44043 22.4554 8.42611 22.4554 10.8801Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.0548,
    cy: 10.8801,
    rx: 2.61538,
    ry: 2.63794,
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3145 4.03516L24.8355 17.7461",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7006 4.07422L11.3555 17.603",
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2575 10.8796C19.2575 11.5529 18.7169 12.0951 18.0546 12.0951C17.3922 12.0951 16.8516 11.5529 16.8516 10.8796C16.8516 10.2062 17.3922 9.66406 18.0546 9.66406C18.7169 9.66406 19.2575 10.2062 19.2575 10.8796Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinerSection);
export default __webpack_public_path__ + "res/media/miner_section.1ce04fbf5af90b9252bb1a9224195f76.svg";
export { ForwardRef as ReactComponent };